import { Theme } from '@material-ui/core/styles';

export const getMuiFormHelperText = (
  theme: Theme,
): Record<string, unknown> => ({
  MuiFormHelperText: {
    root: {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
});
